import { useEffect, useState } from 'react';
import { createPortal } from 'react-dom';
import { ArrowLeft } from 'lucide-react';
import { useNavigate } from 'react-router-dom';
import { prevRoute } from '../utils/navHistory';

// Etiqueta humana por ruta de origen (pathname sin query).
const LABELS: [RegExp, string][] = [
  [/^\/$/, 'inicio'],
  [/^\/alumnos$/, 'alumnos'],
  [/^\/alumnos\/\d+/, 'la ficha anterior'],
  [/^\/profesores$/, 'profesores'],
  [/^\/profesores\/\d+/, 'el profesor'],
  [/^\/cumpleanos$/, 'cumpleaños'],
  [/^\/clases$/, 'clases'],
  [/^\/clases\/\d+/, 'la clase'],
  [/^\/eventos$/, 'eventos'],
  [/^\/eventos\/\d+/, 'el evento'],
  [/^\/prospectos/, 'prospectos'],
  [/^\/mensajes/, 'mensajes'],
  [/^\/finanzas/, 'finanzas'],
  [/^\/membresias/, 'mensualidades'],
  [/^\/reportes/, 'reportes'],
  [/^\/usuarios/, 'usuarios'],
];

/**
 * «Volver» consciente del origen: usa el historial propio de la SPA (navHistory)
 * para decir Y regresar a la pantalla desde la que se llegó (conservando query,
 * p.ej. /alumnos?buscar=ana). Si no hay historial (URL directa/refresh) cae al fallback.
 */
export default function BackButton({ fallback, fallbackLabel }: { fallback: string; fallbackLabel: string }) {
  const navigate = useNavigate();
  const prev = prevRoute();
  const path = prev ? prev.split('?')[0] : null;
  const label = path ? LABELS.find(([re]) => re.test(path))?.[1] : null;
  // En ESCRITORIO el botón se dibuja dentro de la barra superior, pegado al título (hueco
  // `#lm-topbar-back` del AppLayout): ocupaba un renglón propio encima de la ficha y empujaba
  // todo el contenido hacia abajo. En móvil no hay sitio en la barra, así que se queda debajo.
  const [slot, setSlot] = useState<HTMLElement | null>(null);
  useEffect(() => { setSlot(document.getElementById('lm-topbar-back')); }, []);

  const boton = (extra: string) => (
    <button
      onClick={() => navigate(prev ?? fallback)}
      className={`flex items-center gap-2 text-sm text-content-2 transition hover:text-content ${extra}`}>
      <ArrowLeft size={16} /> Volver a {label ?? fallbackLabel}
    </button>
  );

  return (
    <>
      {slot && createPortal(boton('ml-3 border-l border-line pl-3'), slot)}
      {boton('mb-3 md:hidden')}
    </>
  );
}
